import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import {
  getCurrentQuestionId,
  getCurrentAnswerOptionChoiceId,
} from '../selectors.js'
import Tooltip from './Tooltip.js'
import './OptionGroupButton.css'

const OptionGroupButton = ({
  id,
  children,
  body,
  value,
  questionId,
  selectedAnswer,
  setAnswer,
}) => {
  const buttonClassnames = classnames({
    OptionGroupButton: true,
    selected: id === selectedAnswer,
  })
  return (
    <Tooltip title={body}>
      <button
        className={buttonClassnames}
        onClick={() =>
          setAnswer({ questionId, answer: { optionChoiceId: id, value } })
        }
      >
        {children}
      </button>
    </Tooltip>
  )
}

const mapStateToProps = state => ({
  questionId: getCurrentQuestionId(state),
  selectedAnswer: getCurrentAnswerOptionChoiceId(state),
})

const mapDispatchToProps = ({ answersByQuestionId }) => ({
  setAnswer: payload => answersByQuestionId.setAnswer(payload),
})

export default connect(mapStateToProps, mapDispatchToProps)(OptionGroupButton)



// WEBPACK FOOTER //
// ./src/components/OptionGroupButton.js